import {withStyles} from "@material-ui/core/styles";
import {Tooltip} from "@material-ui/core";

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#e5e5e5',
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 12,
    maxWidth: "900px",
    '& .MuiTooltip-arrow::before': {
      backgroundColor: '#e5e5e5',
    }
  },
}))(Tooltip);

export default LightTooltip;
